import { setTranslations } from 'polotno/config';

const MaTranslations = setTranslations({
  toolbar: {
    opacity: 'Opacidade',
    effects: 'Efeitos',
    blur: 'Blur',
    brightness: 'Brilho',
    sepia: 'Sepia',
    grayscale: 'Grayscale',
    textStroke: 'Contorno Texto',
    shadow: 'Sombra',
    border: 'Border',
    cornerRadius: 'Corner Radius',
    position: 'Posição',
    layering: 'Layering',
    toForward: 'Topo',
    up: 'Cima',
    down: 'Baixo',
    toBottom: 'Fundo',
    alignLeft: 'Alinhar à esquerda',
    alignCenter: 'Alinhar ao centro',
    alignRight: 'Alinhar à direita',
    alignTop: 'Alinhar ao topo',
    alignMiddle: 'Alinhar ao meio',
    alignBottom: 'Alinhar ao fundo',
    flip: 'Espelhar',
    flipHorizontally: 'Espelhar horizontalmente',
    flipVertically: 'Espelhar verticalmente',
    fitToBackground: 'Ajustar ao fundo',
    removeBackground: 'Remover fundo',
    cancelRemoveBackground: 'Cancelar',
    confirmRemoveBackground: 'Confirmar',
    crop: 'Recortar',
    cropDone: 'Confirmar',
    cropCancel: 'Cancelar',
    removeClip: 'Remover clip',
    removeMask: 'Remover máscara',
    transparency: 'Transparência',
    lockedDescription: 'Objeto está bloqueado. Desbloquear para prevenir alterações da tela.',
    unlockedDescription: 'Objeto está desbloqueado. Bloquear para prevenir alterações da tela.',
    removeElements: 'Remover elementos',
    duplicateElements: 'Duplicar elementos',
    download: 'Download',
    saveAsImage: 'Guardar como imagem',
    saveAsPDF: 'Guardar como PDF',
    saveAsHDPDF: 'Guardar como PDF Alta Qualidade'
  },
  scale: {
    reset: 'Reset'
  },
  sidePanel: {
    templates: 'Templates',
    searchTemplatesWithSameSize: 'Mostrar templates com o mesmo tamanho',
    searchPlaceholder: 'Procurar...',
    otherFormats: 'Outros formatos',
    noResults: 'Sem resultados',
    text: 'Texto',
    uploadFont: 'Upload font',
    myFonts: 'Minhas fonts',
    photos: 'Imagens',
    elements: 'Elementos',
    upload: 'Upload',
    uploadImage: 'Upload Imagem',
    uploadTip: 'Pretende adicionar as suas imagens?',
    background: 'Fundos',
    resize: 'Tamanhos',
    useMagicResize: 'Utilizar redimensionar mágico',
    magicResizeDescription: 'Redimensionar mágico vai redimensionar automáticamente e mover todos os elementos na tela'
  }
});

export default MaTranslations;
